import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="mt-16 pt-8 border-t border-gray-200">
      <div className="max-w-4xl mx-auto px-4 pb-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
          <div>
            <p>&copy; {new Date().getFullYear()} Training Heart Rate Zones Calculator</p>
          </div>
          <div className="flex gap-6">
            <Link
              to="/more-info"
              className="hover:text-gray-900 transition-colors"
            >
              More Info
            </Link>
            <Link
              to="/cookie-policy"
              className="hover:text-gray-900 transition-colors"
            >
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

